// Adopted from https://stackoverflow.com/a/6969486.
const escapeRegexp = /[.*+?^${}()|[\]\\]/g;

export function escapeStringForRegExp(string) {
  return string.replace(escapeRegexp, '\\$&'); // $& means the whole matched string
}
